module.exports = __webpack_public_path__ + "img/dronisos.defd42d6.png";